import { useState } from 'react';
import { Button, Checkbox, Flex, Form } from 'antd';
import type { FormProps } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

// services
import NotificationService from 'core/services/notification';

// components
import LanguageButton from 'components/language-button/language-button';
import PageTitle from 'components/title/title';

// styles
import styles from './login.module.scss';
import darkLogo from 'assets/images/logo-dark.svg';
import FormPassword from 'components/formPassword/formPassword';
import FormElement from 'components/formElement/formElement';

function BusinessLoginPage() {
	const navigate = useNavigate();
	const { t } = useTranslation();

	const [loginForm] = Form.useForm();
	const [isLoading, setIsLoading] = useState(false);

	type FieldType = {
		email: string;
		password: string;
		remember: boolean;
	};

	const onFinish: FormProps<FieldType>['onFinish'] = async (values) => {
		try {
			console.log(values);
			setIsLoading(true);
			setTimeout(() => {
				navigate('dashboard/mortgages/create');
			}, 1000);
			// setIsLoading(true);
			// const response = await onLogin(values.email, values.password);
			// if (response.data.data.active) {
			// 	authService.setToken(response.data.data.authorization.split('Bearer ')[1], values.remember);
			// 	authService.setUser(response.data.data);
			// 	authService.setPermissions(response.data.data.permissions);
			// 	authService.setRoles(response.data.data.roles);
			// 	navigate('/');
			// } else {
			// 	setIsLoading(false);
			// 	NotificationService.error('Ops !!', 'Your account has been blocked. Please contact our support.');
			// }
		} catch (error: any) {
			setIsLoading(false);
			if (error.status === 401) NotificationService.error('Ops !!', 'These credentials do not match our records.');
			if (error.status === 403)
				NotificationService.error('Ops !!', 'Your account has been marked as inactive. Please contact the administrator to reactivate it.');
		}
	};

	const onFinishFailed: FormProps<FieldType>['onFinishFailed'] = (errorInfo) => {
		console.log(`Failed:`, errorInfo);
		setIsLoading(true);
		setTimeout(() => {
			navigate('dashboard/mortgages/create');
		}, 1000);
	};

	return (
		<>
			<PageTitle name={t('TITLE.LOGIN')} />

			<Flex vertical style={{ minHeight: '100vh', width: '100vw' }} justify="center">
				<Flex justify="center" align="center">
					<motion.div
						initial={window.outerWidth > 768 && { opacity: 0, y: 20 }}
						animate={{ opacity: 1, y: 0 }}
						transition={{
							duration: 0.5,
						}}
						className={styles.formDiv}>
						<div className={`px-3`}>
							<img className="d-block mb-3 m-auto" style={{ width: 150 }} src={darkLogo} alt="logo" />

							<div className="text-center mb-5">
								<h2>{t('LOGIN.TITLE')}</h2>
								<p className="text-light">{t('LOGIN.SUBTITLE')}</p>
							</div>

							<Form form={loginForm} onFinish={onFinish} onFinishFailed={onFinishFailed}>
								<FormElement
									name="email"
									type="email"
									label={t('COMMON.EMAIL')}
									rules={[{ required: true, message: t('COMMON.EMAIL_REQUIRED') }]}
								/>
								<FormPassword
									name="password"
									label={t('COMMON.PASSWORD')}
									rules={[{ required: true, message: t('COMMON.PASSWORD_REQUIRED') }]}
									style={{ maxWidth: 'unset' }}
								/>
								<Flex justify="space-between" align="center" className="my-4">
									<Form.Item name="remember" valuePropName="checked" noStyle>
										<Checkbox>{t('LOGIN.REMEMBER_ME_FOR_30')}</Checkbox>
									</Form.Item>

									<Link to="reset-password" style={{ textDecoration: 'none' }}>
										{t('LOGIN.FORGET_PASSWORD')}
									</Link>
								</Flex>
								<Form.Item style={{ maxWidth: 'unset' }}>
									<Button block type="primary" htmlType="submit" loading={isLoading}>
										{t('LOGIN.LOGIN')}
									</Button>
								</Form.Item>
							</Form>

							<div className="text-center mt-3">
								<LanguageButton />
							</div>
						</div>
					</motion.div>
				</Flex>
			</Flex>
		</>
	);
}

export default BusinessLoginPage;
